import { render, staticRenderFns } from "./editTitle.vue?vue&type=template&id=2caf0f64&"
import script from "./editTitle.vue?vue&type=script&lang=js&"
export * from "./editTitle.vue?vue&type=script&lang=js&"
import style0 from "./editTitle.vue?vue&type=style&index=0&id=2caf0f64&prod&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports